import { Component, input, model, OnInit } from '@angular/core';
import { AbstractControl, FormControl, ReactiveFormsModule } from '@angular/forms';

import { DynamicFormField, Option } from '../../../models/dynamic-form';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRadioModule } from '@angular/material/radio';

@Component( {
  selector: 'app-dynamic-field-radio-buttons',
  imports: [ReactiveFormsModule, MatFormFieldModule, MatRadioModule],
  templateUrl: './dynamic-field-radio-buttons.html',
  styleUrl: './dynamic-field-radio-buttons.css',
} )
export class DynamicFieldRadioButtons implements OnInit
{
  public field = input.required<DynamicFormField>();
  public control = model.required<AbstractControl>();
  public options: Option[] = [];
  public formControl!: FormControl;
  public label: string = '';

  ngOnInit(): void
  {
    this.options = this.field().renderType.options || [];
    this.formControl = this.control() as FormControl;
  }
}
